import React from 'react';
import {
  useSelector,
} from 'react-redux';
import { useField } from 'formik';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import { FormattedMessage } from 'react-intl';
import styles from './index.scss';
import Toggle from '../../toggle/index';
import HelloModal from '../../../../common/components/hello-modal';
import Button, { ButtonType } from 'hellospa/foundation/control/button';
import { ArrowDirection, TooltipPoint } from '../../../foundation/control/tooltip';

const QESToggle = () => {
  const learnMoreLink = 'https://faq.hellosign.com/hc/en-us/articles/360056581532-Qualified-eSignature-';
  const allowQES = useSelector(selectors.allowQES);
  const [isOpen, toggleOpen] = React.useState(false);
  const [QESField, , QESToggle] = useField<boolean>('qes');
  const [recipientsField] = useField<unknown[]>('recipients');
  const [recipientReassignment] = useField<boolean>('recipientReassignment');

  let disabled = false;

  if (recipientsField.value.length > 1 || recipientReassignment.value) {
    disabled = true;
  }

  React.useEffect(() => {
    if (disabled && QESField.value) {
      QESToggle.setValue(false);
    }
  }, [disabled, QESToggle, QESField.value]);

  if (!allowQES) {
    return null;
  }

  return (
    <div className={styles.signerOptionsContainer}>
      <label className={styles.ssToggleLabel} >
        {
          disabled
          && <TooltipPoint className={styles.tooltipUp} arrow={ArrowDirection.Top}>
            <FormattedMessage id=''
              description='Disabled QES message'
              defaultMessage='Qualified eSignature is only available for one signer per document' />
          </TooltipPoint>
        }
        <Toggle
          id="QESToggle"
          indeterminate={false}
          disabled={disabled}
          className={styles.ssToggle}
          {...QESField}
          onChange={(e) => {
            if (e.target.checked) {
              toggleOpen(true);
            }
            return QESField.onChange(e);
          }}
          value=""
          checked={QESField.value}
          data-qa-ref="recipients.fields.qes" />
        <div className={styles.ssLabelText}>
          <FormattedMessage id='' description='QES toggle, main label text' defaultMessage='Enable Qualified eSignature' />
          &nbsp;
          <a href={learnMoreLink} target='_blank' rel='noopener noreferrer'>
            <FormattedMessage id='' description='QES toggle, learn more link in label' defaultMessage='learn more' />
          </a>
        </div>
      </label>
      <HelloModal
        isOpen={isOpen}
        onRequestClose={() => {
          toggleOpen(false);
          QESToggle.setValue(false);
        }}
        buttons={[
          <Button
            key='Cancel'
            kind={ButtonType.Subtle}
            onClick={() => {
              QESToggle.setValue(false);
              toggleOpen(false);
            }}
          ><FormattedMessage id='' description='QES modal, option to cancel' defaultMessage='No Thanks' /></Button>,
          <Button
            key='Ok'
            kind={ButtonType.Primary}
            onClick={() => {
              QESToggle.setValue(true);
              toggleOpen(false);
            }}
          >
            <FormattedMessage id='' description='QES modal, option to enable' defaultMessage='Enable' />
          </Button>,
        ]}
        contentLabel='Enabling Qualified ESignature'
      >
        <FormattedMessage id='' description='QES modal, text in modal body' defaultMessage='This will require the signer to verify their identity with IDNow.' />
        <br />
        <a href={learnMoreLink} target='_blank' rel='noopener noreferrer'>
          <FormattedMessage id='' description='QES modal, text in modal body, learn more link' defaultMessage='Learn more' />
        </a>
      </HelloModal>
    </div>
  );
};

export default QESToggle;
